'use strict';
window.addEventListener('load', function() {
    var optimizelyActiveInterval = setInterval(function() {
        var optimizelyReady =
            typeof window.optimizely === 'object' &&
            !Array.isArray(window.optimizely);

        if (!optimizelyReady) {
            return;
        }

        clearInterval(optimizelyActiveInterval);

        window._mfq = window._mfq || [];
        var variationMap = window.optimizely.get('state').getVariationMap();

        for (var experimentId in variationMap) {
            var activeVariationId = variationMap[experimentId].id;
            var mouseflowTag =
                'AB-TEST_' + experimentId + '_VARIATION_' + activeVariationId;

            window._mfq.push(['tag', mouseflowTag]);
        }
    }, 100);

    setTimeout(function() {
        clearInterval(optimizelyActiveInterval);
    }, 5000);
});
